export interface Message {
  id: string;
  senderId: string;
  senderName: string;
  senderAvatar?: string;
  recipientId: string;
  recipientName: string;
  content: string;
  timestamp: string;
  isRead: boolean;
  messageType: 'text' | 'image' | 'system';
  relatedOrderId?: string;
  relatedProductId?: string;
}

export interface Conversation {
  id: string;
  participantId: string;
  participantName: string;
  participantAvatar?: string;
  participantType: 'buyer' | 'seller';
  lastMessage: Message;
  unreadCount: number;
  lastActivity: string;
  isOnline: boolean;
}

class MessageStore {
  private messages: Message[] = [
    // Conversation with Vintage Finds Co. about a jacket
    {
      id: "msg-1",
      senderId: "seller-1",
      senderName: "Maria Santos",
      senderAvatar: "/logos/8_Comic_Vault_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Hello! Thank you for your interest in the vintage denim jacket. It's in excellent condition and ready to ship.",
      timestamp: "2024-01-15T10:30:00Z",
      isRead: false,
      messageType: "text",
      relatedProductId: "prod-1"
    },
    {
      id: "msg-2",
      senderId: "user-1",
      senderName: "João Silva",
      recipientId: "seller-1",
      recipientName: "Maria Santos",
      content: "Hi Maria! Thanks for the quick response. Could you tell me more about the condition? Are there any signs of wear?",
      timestamp: "2024-01-15T10:35:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-1"
    },
    {
      id: "msg-3",
      senderId: "seller-1",
      senderName: "Maria Santos",
      senderAvatar: "/logos/8_Comic_Vault_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "The jacket is in very good condition! There are some minor signs of wear on the cuffs but nothing major. I've attached photos showing the details.",
      timestamp: "2024-01-15T10:40:00Z",
      isRead: false,
      messageType: "text",
      relatedProductId: "prod-1"
    },
    {
      id: "msg-4",
      senderId: "user-1",
      senderName: "João Silva",
      recipientId: "seller-1",
      recipientName: "Maria Santos",
      content: "Perfect! The photos look great. I'll proceed with the purchase. What's the shipping time to Lisbon?",
      timestamp: "2024-01-15T10:45:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-1"
    },
    {
      id: "msg-5",
      senderId: "seller-1",
      senderName: "Maria Santos",
      senderAvatar: "/logos/8_Comic_Vault_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Excellent! I'll prepare the order right away. Standard shipping to Lisbon takes 2-3 business days. You should receive a tracking number within 24 hours after I ship it.",
      timestamp: "2024-01-15T10:50:00Z",
      isRead: false,
      messageType: "text",
      relatedProductId: "prod-1"
    },

    // Conversation with Retro Electronics about a camera
    {
      id: "msg-6",
      senderId: "seller-2",
      senderName: "Carlos Mendes",
      senderAvatar: "/logos/8_Comic_Vault_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Hi João! I see you're interested in the vintage Polaroid camera. It's a beautiful piece from the 80s and works perfectly!",
      timestamp: "2024-01-14T14:20:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-2"
    },
    {
      id: "msg-7",
      senderId: "user-1",
      senderName: "João Silva",
      recipientId: "seller-2",
      recipientName: "Carlos Mendes",
      content: "Hello Carlos! Yes, I'm very interested. Does it come with the original case and manual?",
      timestamp: "2024-01-14T14:25:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-2"
    },
    {
      id: "msg-8",
      senderId: "seller-2",
      senderName: "Carlos Mendes",
      senderAvatar: "/logos/2_Lisboa_Crafts_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Yes, it comes with the original leather case and instruction manual. The camera has been tested and is in working condition. I can send you some test photos if you'd like!",
      timestamp: "2024-01-14T14:30:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-2"
    },

    // System message about order update
    {
      id: "msg-9",
      senderId: "system",
      senderName: "Retrostall",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Your order #RST-2024-001 has been shipped! Tracking number: PT123456789",
      timestamp: "2024-01-15T11:00:00Z",
      isRead: false,
      messageType: "system",
      relatedOrderId: "order-1"
    },

    // Conversation with Classic Home Decor about furniture
    {
      id: "msg-10",
      senderId: "seller-3",
      senderName: "Ana Costa",
      senderAvatar: "/logos/2_Lisboa_Crafts_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "Good morning! I noticed you added the mid-century coffee table to your favorites. Would you like to know more about it?",
      timestamp: "2024-01-13T09:15:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-3"
    },
    {
      id: "msg-11",
      senderId: "user-1",
      senderName: "João Silva",
      recipientId: "seller-3",
      recipientName: "Ana Costa",
      content: "Hi Ana! Yes, I'm very interested in the coffee table. What's the wood type and dimensions?",
      timestamp: "2024-01-13T09:20:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-3"
    },
    {
      id: "msg-12",
      senderId: "seller-3",
      senderName: "Ana Costa",
      senderAvatar: "/logos/2_Lisboa_Crafts_logo.png",
      recipientId: "user-1",
      recipientName: "João Silva",
      content: "It's made of solid teak wood with a beautiful natural finish. The dimensions are 120cm x 60cm x 45cm height. It's a genuine vintage piece from the 1960s!",
      timestamp: "2024-01-13T09:25:00Z",
      isRead: true,
      messageType: "text",
      relatedProductId: "prod-3"
    }
  ];

  private conversations: Conversation[] = [
    {
      id: "conv-1",
      participantId: "seller-1",
      participantName: "Vintage Finds Co.",
      participantAvatar: "/logos/1_Vintage_Style_Co._logo.png",
      participantType: "seller",
      lastMessage: this.messages.find(m => m.id === "msg-5")!,
      unreadCount: 2,
      lastActivity: "2024-01-15T10:50:00Z",
      isOnline: true
    },
    {
      id: "conv-2",
      participantId: "seller-2",
      participantName: "Retro Electronics",
      participantAvatar: "/logos/3_Retro_Finds_logo.png",
      participantType: "seller",
      lastMessage: this.messages.find(m => m.id === "msg-8")!,
      unreadCount: 0,
      lastActivity: "2024-01-14T14:30:00Z",
      isOnline: false
    },
    {
      id: "conv-3",
      participantId: "seller-3",
      participantName: "Classic Home Decor",
      participantAvatar: "/logos/4_Heritage_Pieces_logo.png",
      participantType: "seller",
      lastMessage: this.messages.find(m => m.id === "msg-12")!,
      unreadCount: 0,
      lastActivity: "2024-01-13T09:25:00Z",
      isOnline: true
    }
  ];

  // Get all messages
  getAllMessages(): Message[] {
    return this.messages;
  }

  // Get messages for a specific conversation
  getMessagesForConversation(participantId: string): Message[] {
    return this.messages.filter(
      msg => msg.senderId === participantId || msg.recipientId === participantId
    ).sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  }

  // Get all conversations
  getAllConversations(): Conversation[] {
    return this.conversations.sort((a, b) =>
      new Date(b.lastActivity).getTime() - new Date(a.lastActivity).getTime()
    );
  }

  // Get conversation by participant ID
  getConversationByParticipantId(participantId: string): Conversation | undefined {
    return this.conversations.find(conv => conv.participantId === participantId);
  }

  // Get total unread message count
  getTotalUnreadCount(): number {
    return this.conversations.reduce((total, conv) => total + conv.unreadCount, 0);
  }

  // Mark messages as read for a conversation
  markConversationAsRead(participantId: string): void {
    const conversation = this.conversations.find(conv => conv.participantId === participantId);
    if (conversation) {
      conversation.unreadCount = 0;
      // Mark all messages in this conversation as read
      this.messages.forEach(msg => {
        if ((msg.senderId === participantId && msg.recipientId === "user-1") ||
            (msg.recipientId === participantId && msg.senderId === "user-1")) {
          msg.isRead = true;
        }
      });
    }
  }

  // Add a new message
  addMessage(message: Omit<Message, 'id' | 'timestamp'>): Message {
    const newMessage: Message = {
      ...message,
      id: `msg-${Date.now()}`,
      timestamp: new Date().toISOString()
    };

    this.messages.push(newMessage);

    // Update conversation
    const conversation = this.conversations.find(conv => conv.participantId === message.senderId);
    if (conversation) {
      conversation.lastMessage = newMessage;
      conversation.lastActivity = newMessage.timestamp;
      if (message.recipientId === "user-1") {
        conversation.unreadCount += 1;
      }
    }

    return newMessage;
  }

  // Get messages between current user and a specific participant
  getMessagesBetweenUsers(currentUserId: string, otherUserId: string): Message[] {
    return this.messages.filter(
      msg => (msg.senderId === currentUserId && msg.recipientId === otherUserId) ||
             (msg.senderId === otherUserId && msg.recipientId === currentUserId)
    ).sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  }
}

export const messageStore = new MessageStore();
